/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Zalo_Test_Phones_Too_ManyInputs */

const vi_error_zalo_test_phones_too_many = /** @type {(inputs: Error_Zalo_Test_Phones_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tối đa ${i?.max} số gửi thử — xoá bớt trước khi thêm.`)
};

/**

* @param {Error_Zalo_Test_Phones_Too_ManyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_test_phones_too_many = /** @type {((inputs: Error_Zalo_Test_Phones_Too_ManyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Test_Phones_Too_ManyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_test_phones_too_many(inputs)
});